/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/api.js"
/*!******************************!*\
  !*** ./js/components/api.js ***!
  \******************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   fetchProductSetupData: () => (/* binding */ fetchProductSetupData)
/* harmony export */ });
/* unused harmony exports parseDiscountPercentage, normalizeStorefrontProduct, normalizeStorefrontProducts, fetchCollectionProducts, fetchAllCollectionProductsFromTemplate */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _storefront_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./storefront.js */ "./js/components/storefront.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_2__);




/**
 * Parse discount percentage from custom.discount metafield (value.percentage.value).
 * API may return value as JSON string or (if pre-parsed) object.
 * @param {string|object|null|undefined} discountMetafieldValue - metafield value
 * @returns {number} 0 if missing or invalid
 */
function parseDiscountPercentage(discountMetafieldValue) {
  var _obj;
  if (discountMetafieldValue == null) return 0;
  var obj = discountMetafieldValue;
  if (typeof discountMetafieldValue === 'string') {
    try {
      obj = JSON.parse(discountMetafieldValue);
    } catch (_unused) {
      return 0;
    }
  }
  var value = (_obj = obj) === null || _obj === void 0 || (_obj = _obj.percentage) === null || _obj === void 0 ? void 0 : _obj.value;
  var n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Normalizes a Storefront API product response to match ProductCard.js expected format
 * @param {Object} storefrontProduct - Product from Storefront API
 * @returns {Object} Normalized product matching ProductCard format
 */
function normalizeStorefrontProduct(storefrontProduct) {
  var _priceRange$minVarian, _priceRange$maxVarian, _metafieldsMap$custom, _storefrontProduct$va;
  // Extract numeric ID from GID format (e.g., "gid://shopify/Product/8704959348903" -> 8704959348903)
  var extractNumericId = gid => {
    if (!gid) return null;
    var match = gid.match(/\/(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
  };

  // Convert price string to cents (number)
  // Storefront API returns amount as string in cents (e.g., "10434.0" = 10434 cents)
  var priceToCents = priceString => {
    if (!priceString) return 0;
    var cents = parseFloat(priceString) * 100;
    return isNaN(cents) ? 0 : cents;
  };
  var productId = extractNumericId(storefrontProduct.id);
  var priceRange = storefrontProduct.priceRange || {};
  var minPriceCents = priceToCents((_priceRange$minVarian = priceRange.minVariantPrice) === null || _priceRange$minVarian === void 0 ? void 0 : _priceRange$minVarian.amount);
  var maxPriceCents = priceToCents((_priceRange$maxVarian = priceRange.maxVariantPrice) === null || _priceRange$maxVarian === void 0 ? void 0 : _priceRange$maxVarian.amount);
  var featuredImage = storefrontProduct.featuredImage;

  // Build images array matching expected format
  var images = [];
  if (featuredImage !== null && featuredImage !== void 0 && featuredImage.url) {
    images.push({
      width: "1920",
      height: "1080",
      url: featuredImage.url,
      alt: featuredImage.altText || storefrontProduct.title || "",
      aspectRatio: 1
    });
  }

  // Extract metafields and build nested structure
  var metafields = storefrontProduct.metafields || [];
  var metafieldsMap = {};
  metafields.forEach(metafield => {
    var key = metafield === null || metafield === void 0 ? void 0 : metafield.key;
    var namespace = metafield === null || metafield === void 0 ? void 0 : metafield.namespace;
    if (namespace && key) {
      if (!metafieldsMap[namespace]) {
        metafieldsMap[namespace] = {};
      }
      metafieldsMap[namespace][key] = metafield.value;
    }
  });

  // Applicable price from custom.discount (value.percentage.value) (same logic as price.liquid / product-json.liquid)
  var discountPercentage = parseDiscountPercentage((_metafieldsMap$custom = metafieldsMap.custom) === null || _metafieldsMap$custom === void 0 ? void 0 : _metafieldsMap$custom.discount) || 0;
  var useApplicablePrice = discountPercentage > 0;

  // Build variants array - prices in cents (matching provided example format)
  var variants = [];
  if ((_storefrontProduct$va = storefrontProduct.variants) !== null && _storefrontProduct$va !== void 0 && _storefrontProduct$va.edges && storefrontProduct.variants.edges.length > 0) {
    storefrontProduct.variants.edges.forEach(variantEdge => {
      var _variant$price, _variant$compareAtPri, _metafieldsMap$custom2;
      var variant = variantEdge.node;
      var variantId = extractNumericId(variant.id);
      var variantPriceCents = priceToCents((_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : _variant$price.amount);
      var variantCompareAtPriceCents = priceToCents((_variant$compareAtPri = variant.compareAtPrice) === null || _variant$compareAtPri === void 0 ? void 0 : _variant$compareAtPri.amount);
      var finalPrice, finalCompareAtPrice;
      if (useApplicablePrice) {
        var discountDecimal = discountPercentage / 100;
        var discountAmount = variantPriceCents * discountDecimal;
        finalPrice = Math.round(variantPriceCents - discountAmount);
        finalCompareAtPrice = variantPriceCents;
      } else {
        finalPrice = variantPriceCents;
        finalCompareAtPrice = variantCompareAtPriceCents;
      }

      // SKU from variant or metafield
      var sku = variant.sku || ((_metafieldsMap$custom2 = metafieldsMap.custom) === null || _metafieldsMap$custom2 === void 0 ? void 0 : _metafieldsMap$custom2.spec_model_number) || null;
      variants.push({
        id: variantId,
        price: finalPrice,
        compareAtPrice: finalCompareAtPrice,
        available: variant.availableForSale !== false,
        sku: sku
      });
    });
  } else {
    var _metafieldsMap$custom3;
    // Fallback: create minimal variant if no variants in response
    var finalPrice, finalCompareAtPrice;
    if (useApplicablePrice) {
      var discountDecimal = discountPercentage / 100;
      var discountAmount = minPriceCents * discountDecimal;
      finalPrice = Math.round(minPriceCents - discountAmount);
      finalCompareAtPrice = minPriceCents;
    } else {
      finalPrice = minPriceCents;
      finalCompareAtPrice = 0;
    }
    var fallbackSku = ((_metafieldsMap$custom3 = metafieldsMap.custom) === null || _metafieldsMap$custom3 === void 0 ? void 0 : _metafieldsMap$custom3.spec_model_number) || null;
    variants.push({
      id: productId,
      price: finalPrice,
      compareAtPrice: finalCompareAtPrice,
      available: storefrontProduct.availableForSale !== false,
      sku: fallbackSku
    });
  }
  return {
    id: productId,
    handle: storefrontProduct.handle || "",
    title: storefrontProduct.title || "",
    url: "/products/".concat(storefrontProduct.handle || ""),
    vendor: storefrontProduct.vendor || "",
    productType: storefrontProduct.productType || "",
    tags: storefrontProduct.tags || [],
    templateSuffix: storefrontProduct.templateSuffix || null,
    available: storefrontProduct.availableForSale !== false,
    priceRange: {
      min: minPriceCents,
      max: maxPriceCents || minPriceCents
    },
    images: images,
    variants: variants,
    metafields: metafieldsMap,
    hasApplicablePrice: useApplicablePrice
  };
}

/**
 * Normalizes an array of Storefront API products
 * @param {Array} storefrontProducts - Array of products from Storefront API
 * @returns {Array} Array of normalized products
 */
function normalizeStorefrontProducts(storefrontProducts) {
  if (!Array.isArray(storefrontProducts)) {
    return [];
  }
  return storefrontProducts.map(normalizeStorefrontProduct);
}
function fetchProductSetupData(_x) {
  return _fetchProductSetupData.apply(this, arguments);
}
function _fetchProductSetupData() {
  _fetchProductSetupData = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (handle) {
    var url = "".concat(window.Shopify.routes.root, "products/").concat(handle, "?view=setup");
    if (!url) {
      throw new Error("Product setup URL not found");
    }
    try {
      var response = yield fetch(url, {
        method: "GET"
      });
      if (!response.ok) {
        throw new Error("Failed to fetch product data: ".concat(response.status));
      }
      return yield json_6__WEBPACK_IMPORTED_MODULE_2___default().parse(yield response.text());
    } catch (error) {
      console.error("Error fetching product setup data:", error);
      throw error;
    }
  });
  return _fetchProductSetupData.apply(this, arguments);
}
function fetchCollectionProducts(_x2) {
  return _fetchCollectionProducts.apply(this, arguments);
}

/**
 * Fetches all products from a collection using the Liquid template endpoint
 * Makes requests in batches of 5 to avoid overwhelming the server
 * @param {Object} config - Configuration object
 * @param {string} config.collectionHandle - Collection handle
 * @param {number} config.productsCount - Total number of products in collection
 * @param {number} config.perPage - Items per page (default: 20, max: 250)
 * @returns {Promise<Array>} Array of all products
 */
function _fetchCollectionProducts() {
  _fetchCollectionProducts = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (config) {
    var apiClient = (0,_storefront_js__WEBPACK_IMPORTED_MODULE_1__.createStorefrontApiClient)();
    var {
      collectionHandle,
      filters = [],
      first = 24,
      after = null,
      metafieldIdentifiers = [],
      sortKey = 'BEST_SELLING',
      reverse = false
    } = config;
    if (!collectionHandle) {
      throw new Error("collectionHandle is required");
    }
    var productFilters = (0,_storefront_js__WEBPACK_IMPORTED_MODULE_1__.buildProductFilter)(filters);

    // Applicable price is derived from custom.discount (value.percentage.value) (same as price.liquid / product-json.liquid)
    var discountMetafield = {
      namespace: "custom",
      key: "discount"
    };
    var customSpecModelNumberMetafield = {
      namespace: "custom",
      key: "spec_model_number"
    };
    var addOnsMetafield = {
      namespace: "custom",
      key: "add_ons"
    };
    var mandatoryProductsMetafield = {
      namespace: "custom",
      key: "mandatory_products"
    };
    var surchargeCaliforniaMetafield = {
      namespace: "custom",
      key: "surcharge_for_california_in_percentage"
    };
    var metafieldsFragment = (0,_storefront_js__WEBPACK_IMPORTED_MODULE_1__.buildMetafieldsFragment)([...metafieldIdentifiers, discountMetafield, customSpecModelNumberMetafield, addOnsMetafield, mandatoryProductsMetafield, surchargeCaliforniaMetafield]);
    var query = (0,_storefront_js__WEBPACK_IMPORTED_MODULE_1__.buildGraphQLQuery)("CollectionProducts", {
      handle: "String!",
      first: "Int",
      after: "String",
      filters: "[ProductFilter!]",
      sortKey: "ProductCollectionSortKeys",
      reverse: "Boolean"
    }, "collection(handle: $handle) {\n      products(first: $first, after: $after, filters: $filters, sortKey: $sortKey, reverse: $reverse) {\n        filters {\n          id\n          label\n          type\n          values {\n            id\n            label\n            count\n            input\n          }\n        }\n        edges {\n          node {\n            id\n            handle\n            title\n            vendor\n            productType\n            tags\n            availableForSale\n            priceRange {\n              minVariantPrice {\n                amount\n                currencyCode\n              }\n              maxVariantPrice {\n                amount\n                currencyCode\n              }\n            }\n            featuredImage {\n              url\n              altText\n            }\n            variants(first: 250) {\n              edges {\n                node {\n                  id\n                  price {\n                    amount\n                    currencyCode\n                  }\n                  compareAtPrice {\n                    amount\n                    currencyCode\n                  }\n                  availableForSale\n                  sku\n                }\n              }\n            }\n            ".concat(metafieldsFragment, "\n          }\n          cursor\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }"));
    try {
      var response = yield apiClient.post("", {
        query,
        variables: {
          handle: collectionHandle,
          first,
          after,
          filters: productFilters.length > 0 ? productFilters : null,
          sortKey,
          reverse
        }
      });
      if (response.data.errors) {
        throw new Error("GraphQL errors: ".concat(response.data.errors.map(e => e.message).join(", ")));
      }
      var rawProducts = response.data.data.collection.products.edges.map(edge => edge.node);
      var normalizedProducts = normalizeStorefrontProducts(rawProducts);
      var _filters = response.data.data.collection.products.filters || [];
      return {
        products: normalizedProducts,
        pageInfo: response.data.data.collection.products.pageInfo,
        filters: _filters
      };
    } catch (error) {
      console.error("Error fetching collection products:", error);
      throw error;
    }
  });
  return _fetchCollectionProducts.apply(this, arguments);
}
function fetchAllCollectionProductsFromTemplate(_x3) {
  return _fetchAllCollectionProductsFromTemplate.apply(this, arguments);
}
function _fetchAllCollectionProductsFromTemplate() {
  _fetchAllCollectionProductsFromTemplate = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (config) {
    var {
      collectionHandle,
      productsCount
    } = config;
    if (!collectionHandle) {
      throw new Error("collectionHandle is required");
    }
    if (!productsCount || productsCount === 0) {
      return [];
    }
    var itemsPerPage = 250;
    var totalPages = Math.ceil(productsCount / itemsPerPage);
    var parallelBatchSize = 15; // Number of parallel requests per batch
    var allProducts = [];
    try {
      // Create array of page numbers to fetch
      var pagesToFetch = Array.from({
        length: totalPages
      }, (_, i) => i + 1);

      // Process pages in batches
      while (pagesToFetch.length > 0) {
        // Take a batch of pages to process in parallel
        var batch = pagesToFetch.splice(0, parallelBatchSize);

        // Make parallel requests for this batch
        var batchResults = yield Promise.all(batch.map(page => {
          var url = "".concat(window.Shopify.routes.root, "collections/").concat(collectionHandle, "?view=products-paginated&page=").concat(page);
          return fetch(url, {
            method: "GET"
          }).then(response => {
            if (!response.ok) {
              throw new Error("Failed to fetch page ".concat(page, ": ").concat(response.status));
            }
            return response.json();
          }).then(products => {
            if (!Array.isArray(products)) {
              console.warn("Page ".concat(page, " returned non-array data:"), products);
              return [];
            }
            return products;
          }).catch(error => {
            console.error("Error fetching page ".concat(page, ":"), error);
            return []; // Return empty array on error to continue processing
          });
        }));

        // Collect products from batch results
        batchResults.forEach(products => {
          if (Array.isArray(products)) {
            allProducts.push(...products);
          }
        });
      }
      return allProducts;
    } catch (error) {
      console.error("Error fetching all collection products from template:", error);
      throw error;
    }
  });
  return _fetchAllCollectionProductsFromTemplate.apply(this, arguments);
}

/***/ },

/***/ "./js/components/product-customise.js"
/*!********************************************!*\
  !*** ./js/components/product-customise.js ***!
  \********************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports quickAddToCart, customiseProduct */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _react_product_setup_drawer_js_drawer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./react/product-setup-drawer.js/drawer */ "./js/components/react/product-setup-drawer.js/drawer.js");



/**
 * Get selected variant ID from product form
 */
var getSelectedVariantId = productInfo => {
  var _productInfo$querySel;
  var variantJson = productInfo === null || productInfo === void 0 || (_productInfo$querySel = productInfo.querySelector('variant-selects [data-selected-variant]')) === null || _productInfo$querySel === void 0 ? void 0 : _productInfo$querySel.innerHTML;
  if (!variantJson) return null;
  try {
    var variant = JSON.parse(variantJson);
    return (variant === null || variant === void 0 ? void 0 : variant.id) || null;
  } catch (_unused) {
    return null;
  }
};

/**
 * Get quantity from quantity input
 */
var getQuantity = productInfo => {
  var quantityInput = productInfo === null || productInfo === void 0 ? void 0 : productInfo.querySelector('quantity-input input[name="quantity"]');
  return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
};
var setButtonLoading = (el, loading) => {
  if (!el) return;
  if (loading) {
    el.setAttribute('data-state', 'loading');
    el.setAttribute('aria-busy', 'true');
  } else {
    el.removeAttribute('data-state');
    el.removeAttribute('aria-busy');
  }
};
var getVariantIdFromTrigger = trigger => {
  var _trigger$dataset;
  var raw = trigger === null || trigger === void 0 || (_trigger$dataset = trigger.dataset) === null || _trigger$dataset === void 0 ? void 0 : _trigger$dataset.variantId;
  return raw != null && raw !== '' ? Number(raw) : null;
};
var getProductInfo = trigger => (trigger === null || trigger === void 0 ? void 0 : trigger.closest('product-info')) || document.querySelector('product-info[id^="MainProduct"]');

/**
 * Direct add to cart (single variant) then open cart drawer — normal flow, no configurator
 */
var quickAddToCart = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (trigger) {
    var variantId = getVariantIdFromTrigger(trigger);
    if (!variantId) return;
    setButtonLoading(trigger, true);
    var quantity = parseInt(trigger.dataset.quantity, 10) || 1;
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
      bubbles: true,
      detail: {
        sections: sectionsToBundle
      }
    }));
    try {
      var _window$FoxTheme, _window$FoxTheme$publ, _document$querySelect, _document$querySelect2;
      var response = yield fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity
          }],
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        })
      });
      if (!response.ok) {
        var err = yield response.json();
        throw new Error(err.description || 'Failed to add to cart');
      }
      var {
        sections
      } = yield response.json();
      var cartResponse = yield fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      var cartJson = yield cartResponse.json();
      cartJson.sections = sections;
      (_window$FoxTheme = window.FoxTheme) === null || _window$FoxTheme === void 0 || (_window$FoxTheme = _window$FoxTheme.pubsub) === null || _window$FoxTheme === void 0 || (_window$FoxTheme$publ = _window$FoxTheme.publish) === null || _window$FoxTheme$publ === void 0 || _window$FoxTheme$publ.call(_window$FoxTheme, window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        cart: cartJson
      });
      (_document$querySelect = document.querySelector('cart-drawer')) === null || _document$querySelect === void 0 || (_document$querySelect2 = _document$querySelect.show) === null || _document$querySelect2 === void 0 || _document$querySelect2.call(_document$querySelect);
    } catch (e) {
      console.error('Quick add to cart:', e);
    } finally {
      setButtonLoading(trigger, false);
    }
  });
  return function quickAddToCart(_x) {
    return _ref.apply(this, arguments);
  };
}();
var customiseProduct = trigger => {
  var _getVariantIdFromTrig;
  var productInfo = getProductInfo(trigger);
  window.updateDrawerComponent(_react_product_setup_drawer_js_drawer__WEBPACK_IMPORTED_MODULE_1__["default"], {
    handle: trigger.dataset.productHandle,
    selectedVariantId: (_getVariantIdFromTrig = getVariantIdFromTrigger(trigger)) !== null && _getVariantIdFromTrig !== void 0 ? _getVariantIdFromTrig : getSelectedVariantId(productInfo),
    quantity: getQuantity(productInfo)
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  document.addEventListener('click', ev => {
    var quickAdd = ev.target.closest('[data-quick-add]');
    if (quickAdd) {
      ev.preventDefault();
      ev.stopPropagation();
      quickAddToCart(quickAdd);
      return;
    }
    var trigger = ev.target.closest('[data-customise-trigger]');
    if (!trigger) return;
    ev.preventDefault();
    ev.stopPropagation();
    setButtonLoading(trigger, true);
    customiseProduct(trigger);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setButtonLoading(trigger, false));
    });
  });
});

/***/ },

/***/ "./js/components/react/drawer/index.js"
/*!*********************************************!*\
  !*** ./js/components/react/drawer/index.js ***!
  \*********************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/extends */ "./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./store */ "./js/components/react/drawer/store.js");
/* harmony import */ var _product_setup_drawer_js_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../product-setup-drawer.js/store */ "./js/components/react/product-setup-drawer.js/store.js");
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @headlessui/react */ "./node_modules/@headlessui/react/dist/components/dialog/dialog.js");
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lucide-react */ "./node_modules/lucide-react/dist/esm/icons/arrow-left.js");
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lucide-react */ "./node_modules/lucide-react/dist/esm/icons/x.js");


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var DrawerHeader = _ref => {
  var {
    title,
    onClose
  } = _ref;
  var currentStep = (0,_product_setup_drawer_js_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.currentStep);
  var prevStep = (0,_product_setup_drawer_js_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.prevStep);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex tw-items-center tw-h-[58px] tw-justify-between tw-p-[16px] lg:tw-px-[30px] py-md tw-sticky tw-top-0 tw-bg-white tw-z-[31474836479]",
    style: {
      borderBottom: "1px solid #DDDDDD"
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex tw-items-center tw-gap-[8px]"
  }, currentStep !== 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    onClick: prevStep,
    className: "tw-cursor-pointer tw-flex tw-items-center tw-justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(lucide_react__WEBPACK_IMPORTED_MODULE_6__["default"], {
    size: 24
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h2", {
    className: "tw-text-[24px] lineHeight-1 tw-font-bold tw-text-[#092846]"
  }, title)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    onClick: onClose,
    className: "tw-p-0 tw-h-[24px] tw-w-[24px] text-h4 hover:tw-bg-gray-100 tw-transition-colors tw-border-none tw-outline-none focus:tw-outline-none focus:tw-ring-0 tw-rounded-none",
    "aria-label": "Close drawer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(lucide_react__WEBPACK_IMPORTED_MODULE_7__["default"], {
    size: 24
  })));
};
var DefaultContent = () => {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h1", {
    className: "p-4"
  }, "Default content");
};
var TRANSITION_DURATION = 300;
var DrawerWrapper = () => {
  var [ContentComponent, setContentComponent] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
  var [componentProps, setComponentProps] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
  var [drawerTitle, setDrawerTitle] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("Drawer");
  var [isAnimating, setIsAnimating] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var [isDialogOpen, setIsDialogOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var {
    isOpen,
    closeDrawer,
    openDrawer
  } = (0,_store__WEBPACK_IMPORTED_MODULE_3__.useDrawerStore)();

  // Handle open/close with delayed unmount for close animation
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (isOpen) {
      // Opening: mount dialog first, then animate
      setIsDialogOpen(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsAnimating(true);
        });
      });
    } else {
      // Closing: animate first, then unmount dialog
      setIsAnimating(false);
      var timer = setTimeout(() => {
        setIsDialogOpen(false);
      }, TRANSITION_DURATION);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // Update component with optional props and title, and open the drawer
  var updateComponent = function updateComponent(NewComponent) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Customize";
    setContentComponent(() => NewComponent);
    setComponentProps(props);
    setDrawerTitle(title);
    openDrawer(); // Always open when updating component
  };

  // Update just the props without changing the component
  var updateComponentProps = newProps => {
    setComponentProps(prev => _objectSpread(_objectSpread({}, prev), newProps));
  };

  // Handle close from Dialog (backdrop click, escape key)
  var handleDialogClose = () => {
    closeDrawer();
  };
  window.openDrawer = openDrawer;
  window.closeDrawer = closeDrawer;
  window.updateDrawerComponent = updateComponent;
  window.updateDrawerProps = updateComponentProps;
  window.setDrawerTitle = setDrawerTitle;
  var renderContent = () => {
    if (ContentComponent) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(ContentComponent, (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({}, componentProps, {
        closeDrawer: closeDrawer
      }));
    }
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(DefaultContent, null);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__.Dialog, {
    open: isDialogOpen,
    onClose: handleDialogClose,
    className: "tw-relative dialog-one tw-z-[31474836479]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__.DialogBackdrop, {
    className: "tw-fixed tw-inset-0 tw-bg-black/40 !tw-block",
    style: {
      transition: "opacity 300ms ease-out",
      opacity: isAnimating ? 1 : 0
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-fixed tw-inset-0 tw-overflow-hidden"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-absolute tw-inset-0 tw-overflow-hidden"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-pointer-events-none tw-fixed tw-inset-y-0 tw-right-0 tw-flex tw-max-w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__.DialogPanel, {
    className: "tw-flex tw-flex-col tw-pointer-events-auto tw-w-[500px] tw-max-w-full tw-min-h-[100dvh] tw-bg-white tw-shadow-xl",
    style: {
      transition: "transform 300ms ease-out",
      transform: isAnimating ? "translateX(0)" : "translateX(100%)"
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(DrawerHeader, {
    title: drawerTitle,
    onClose: closeDrawer
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-overflow-y-auto tw-h-full"
  }, renderContent()))))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DrawerWrapper);

/***/ },

/***/ "./js/components/react/drawer/store.js"
/*!*********************************************!*\
  !*** ./js/components/react/drawer/store.js ***!
  \*********************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   useDrawerStore: () => (/* binding */ useDrawerStore)
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! zustand */ "./node_modules/zustand/esm/react.mjs");


/**
 * Generic Drawer Store
 * Only manages drawer UI state (open/close)
 * Content-specific state (including loading) should live in the content component's own store
 */
var useDrawerStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__.create)(set => ({
  isOpen: false,
  openDrawer: () => set({
    isOpen: true
  }),
  closeDrawer: () => set({
    isOpen: false
  })
}));

/***/ },

/***/ "./js/sections/brands-collection.js"
/*!******************************************!*\
  !*** ./js/sections/brands-collection.js ***!
  \******************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var brandsCollection = () => {
  var updateFilterIndicator = (button, indicator) => {
    if (!button || !indicator) return;
    var buttonRect = button.getBoundingClientRect();
    var containerRect = button.closest('[data-filters-container]').getBoundingClientRect();
    var leftOffset = buttonRect.left - containerRect.left;
    indicator.style.left = "".concat(leftOffset, "px");
  };
  return {
    init: () => {
      var sections = document.querySelectorAll('[data-section-id].brands-collection-section');
      if (!sections.length) {
        console.warn('Brands Collection: No sections found');
        return;
      }
      sections.forEach(section => {
        var filterButtons = section.querySelectorAll('[data-filter]');
        var collectionItems = section.querySelectorAll('[data-collection-item]');
        var filterIndicator = section.querySelector('[data-filter-indicator]');
        var filtersContainer = section.querySelector('[data-filters-container]');
        if (!filterButtons.length) {
          console.warn('Brands Collection: No filter buttons found');
          return;
        }
        if (!collectionItems.length) {
          console.warn('Brands Collection: No collection items found');
          return;
        }

        // Add class to items in last row for proper border handling
        var updateLastRowBorders = () => {
          var visibleItems = Array.from(collectionItems).filter(item => item.style.display !== 'none');
          if (visibleItems.length === 0) return;

          // Get columns from CSS or default
          var grid = section.querySelector('[data-collections-grid]');
          var computedStyle = window.getComputedStyle(grid);
          var columns = computedStyle.gridTemplateColumns.split(' ').length;

          // Remove previous last-row class
          visibleItems.forEach(item => item.classList.remove('brands-collection__item--last-row'));

          // Calculate last row start index
          var totalItems = visibleItems.length;
          var lastRowStart = Math.floor((totalItems - 1) / columns) * columns;

          // Add class to items in last row
          visibleItems.forEach((item, index) => {
            if (index >= lastRowStart) {
              item.classList.add('brands-collection__item--last-row');
            }
          });
        };

        // Function to scroll to show next button after clicked button
        var scrollToShowNext = (clickedButton, container) => {
          if (!clickedButton || !container) return;

          // Find the next button (sibling)
          var nextButton = clickedButton.nextElementSibling;
          if (!nextButton) return; // No next button

          var containerRect = container.getBoundingClientRect();
          var nextButtonRect = nextButton.getBoundingClientRect();

          // Check if next button is fully visible
          var isNextButtonVisible = nextButtonRect.left >= containerRect.left && nextButtonRect.right <= containerRect.right;

          // If next button is not fully visible, scroll to show it
          if (!isNextButtonVisible) {
            // Calculate scroll position to show the next button
            var scrollLeft = nextButton.offsetLeft - container.offsetLeft - container.offsetWidth / 2 + nextButton.offsetWidth / 2;
            container.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }
        };

        // Function to filter items
        var filterItems = filterLetter => {
          collectionItems.forEach(item => {
            var itemLetter = item.getAttribute('data-filter-letter');
            // When 'All' is selected, show ALL items
            if (filterLetter == 'All') {
              item.style.display = '';
            } else if (itemLetter === filterLetter) {
              item.style.display = '';
            } else {
              item.style.display = 'none';
            }
          });
        };

        // Set initial filter indicator position and apply initial filter
        var firstButton = filterButtons[0];
        if (firstButton && filterIndicator) {
          updateFilterIndicator(firstButton, filterIndicator);
          var initialFilter = firstButton.getAttribute('data-filter');
          filterItems(initialFilter);
        }

        // Filter button click handlers
        filterButtons.forEach(button => {
          button.addEventListener('click', () => {
            // Prevent click if button is disabled
            if (button.disabled || button.classList.contains('brands-collection__filter-btn--disabled')) {
              return;
            }
            var filterLetter = button.getAttribute('data-filter');

            // Scroll to show next button if it's not visible (mobile/tablet)
            if (filtersContainer && window.innerWidth <= 1024) {
              scrollToShowNext(button, filtersContainer);
            }

            // Update button states
            filterButtons.forEach(btn => {
              var isActive = btn === button;
              if (isActive) {
                btn.classList.add('tw-bg-[#027db3]');
                var span = btn.querySelector('span');
                if (span) {
                  span.classList.remove('tw-text-[#666]');
                  span.classList.add('tw-text-white');
                }
              } else {
                btn.classList.remove('tw-bg-[#027db3]');
                var _span = btn.querySelector('span');
                if (_span) {
                  _span.classList.add('tw-text-[#666]');
                  _span.classList.remove('tw-text-white');
                }
              }
            });

            // Update filter indicator position
            if (filterIndicator) {
              updateFilterIndicator(button, filterIndicator);
            }

            // Filter collection items
            filterItems(filterLetter);
            // Update last row borders after filtering
            updateLastRowBorders();
          });
        });

        // Initial last row border update
        updateLastRowBorders();

        // Mobile carousel for filters (if needed)
        if (window.innerWidth <= 767 && filtersContainer) {
          var isDown = false;
          var startX;
          var scrollLeft;
          filtersContainer.addEventListener('mousedown', e => {
            isDown = true;
            filtersContainer.style.cursor = 'grabbing';
            startX = e.pageX - filtersContainer.offsetLeft;
            scrollLeft = filtersContainer.scrollLeft;
          });
          filtersContainer.addEventListener('mouseleave', () => {
            isDown = false;
            filtersContainer.style.cursor = 'grab';
          });
          filtersContainer.addEventListener('mouseup', () => {
            isDown = false;
            filtersContainer.style.cursor = 'grab';
          });
          filtersContainer.addEventListener('mousemove', e => {
            if (!isDown) return;
            e.preventDefault();
            var x = e.pageX - filtersContainer.offsetLeft;
            var walk = (x - startX) * 2;
            filtersContainer.scrollLeft = scrollLeft - walk;
          });

          // Touch events for mobile
          var touchStartX = 0;
          var touchScrollLeft = 0;
          filtersContainer.addEventListener('touchstart', e => {
            touchStartX = e.touches[0].pageX - filtersContainer.offsetLeft;
            touchScrollLeft = filtersContainer.scrollLeft;
          });
          filtersContainer.addEventListener('touchmove', e => {
            if (!e.touches[0]) return;
            var x = e.touches[0].pageX - filtersContainer.offsetLeft;
            var walk = (x - touchStartX) * 2;
            filtersContainer.scrollLeft = touchScrollLeft - walk;
          });

          // Enable horizontal scrolling
          filtersContainer.style.overflowX = 'auto';
          filtersContainer.style.cursor = 'grab';
          filtersContainer.style.scrollBehavior = 'smooth';
        }
      });
    }
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  brandsCollection().init();
});

/***/ },

/***/ "./js/sections/collection-list-slider.js"
/*!***********************************************!*\
  !*** ./js/sections/collection-list-slider.js ***!
  \***********************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  if (!customElements.get('collection-list-slider')) {
    customElements.define('collection-list-slider', class CollectionLogosSlider extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.brand-logos__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination'
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper'
        };
        this.container = this.closest('.brand-logos__container');
        this.sectionContent = this.closest('.section__content');
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseFloat(this.dataset.items) || 6;
        this.tabletItems = parseInt(this.dataset.tabletItems) || 3;
        this.laptopItems = parseInt(this.dataset.laptopItems) || 5;
        this.itemSize = this.dataset.itemSize || 'auto';
        this.columnsDesktop = parseInt(this.dataset.columnsDesktop, 10) || 6;
        this.columnsMobile = parseFloat(this.dataset.columnsMobile) || 2.5;
        this.navigationPosition = this.dataset.navigationPosition || 'middle';
        this.sliderInstance = false;
        if (!this.enableSlider) return;
        this.initSlider();
      }
      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        var columnGap = (window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap') || '').trim();
        var spaceBetween = 0;
        if (columnGap) {
          var val = parseFloat(columnGap);
          if (!isNaN(val)) {
            var rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
            if (columnGap.includes('rem')) spaceBetween = val * rootFontSize;else if (columnGap.includes('px')) spaceBetween = val;
          }
        }
        var dataSpace = this.dataset.spaceBetween;
        if (dataSpace !== undefined && dataSpace !== '') spaceBetween = parseFloat(dataSpace) || spaceBetween;

        // Look for controls in section__content (parent of brand-logos__container)
        var controlsContainer = this.sectionContent || this.container;
        var useFixedSize = this.itemSize === 'fixed';
        var mobileSlides = useFixedSize ? this.columnsMobile : 2;
        var tabletSlides = useFixedSize ? Math.min(4, this.columnsDesktop) : this.tabletItems;
        var laptopSlides = useFixedSize ? this.columnsDesktop > 6 ? this.columnsDesktop - 1 : this.columnsDesktop : this.laptopItems;
        var desktopSlides = useFixedSize ? this.columnsDesktop : this.items;
        this.sliderOptions = {
          slidesPerView: mobileSlides,
          spaceBetween: 16,
          slidesOffsetAfter: 32,
          navigation: {
            nextEl: controlsContainer.querySelector(this.selectors.nextEl),
            prevEl: controlsContainer.querySelector(this.selectors.prevEl)
          },
          pagination: {
            el: controlsContainer.querySelector(this.selectors.pagination),
            type: 'progressbar'
          },
          breakpoints: {
            768: {
              slidesPerView: tabletSlides
            },
            1024: {
              slidesPerView: laptopSlides
            },
            1280: {
              slidesPerView: desktopSlides
            }
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true
        };
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
      }
      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    });
  }
});

/***/ },

/***/ "./js/sections/compare-price-decrypt.js"
/*!**********************************************!*\
  !*** ./js/sections/compare-price-decrypt.js ***!
  \**********************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ decryptPrices)
/* harmony export */ });
var BASE_MAP = ["Q", "M", "Z", "A", "L", "X", "P", "R", "D", "K"];
function unrotate(index, shift) {
  return (index - shift + 10) % 10;
}
function decryptAndValidatePrice(encrypted, variantId) {
  var shift = Number(variantId) % 10;
  var decrypted = encrypted.split("").map(char => {
    var index = BASE_MAP.indexOf(char);
    if (index === -1) return char;
    return unrotate(index, shift);
  }).join("");
  if (decrypted.length < 2) return null;
  var body = decrypted.slice(0, -1);
  var provided = Number(decrypted.slice(-1));
  var sum = body.split("").filter(c => c >= "0" && c <= "9").reduce((a, d) => a + Number(d), 0);
  var expected = (sum + shift) % 10;
  if (expected !== provided) return null;
  return Number(body);
}
function decryptPrices() {
  document.querySelectorAll(".compare-price-decrypt").forEach(el => {
    var encrypted = el.dataset.encrypted;
    var variantId = el.dataset.variant;
    var price = decryptAndValidatePrice(encrypted, variantId);
    if (price !== null) {
      el.innerHTML = "$" + Number(price).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } else {
      el.style.display = "none";
    }
  });
}

/***/ },

/***/ "./js/sections/global.js"
/*!*******************************!*\
  !*** ./js/sections/global.js ***!
  \*******************************/
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _mega_menu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mega-menu */ "./js/sections/mega-menu.js");
/* harmony import */ var _brands_collection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./brands-collection */ "./js/sections/brands-collection.js");
/* harmony import */ var ReactComponents_drawer_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ReactComponents/drawer/index.js */ "./js/components/react/drawer/index.js");
/* harmony import */ var _components_product_customise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../components/product-customise */ "./js/components/product-customise.js");
/* harmony import */ var _components_react_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../components/react-wrapper */ "./js/components/react-wrapper.js");
/* harmony import */ var _page_redirection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./page-redirection */ "./js/sections/page-redirection.js");
/* harmony import */ var _collection_list_slider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./collection-list-slider */ "./js/sections/collection-list-slider.js");
/* harmony import */ var _compare_price_decrypt__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./compare-price-decrypt */ "./js/sections/compare-price-decrypt.js");








document.addEventListener('DOMContentLoaded', () => {
  _mega_menu__WEBPACK_IMPORTED_MODULE_0__["default"].init();
  (0,_components_product_customise__WEBPACK_IMPORTED_MODULE_3__["default"])();
  (0,_components_react_wrapper__WEBPACK_IMPORTED_MODULE_4__["default"])(ReactComponents_drawer_index_js__WEBPACK_IMPORTED_MODULE_2__["default"], "react-drawer");
  (0,_page_redirection__WEBPACK_IMPORTED_MODULE_5__["default"])();
  (0,_collection_list_slider__WEBPACK_IMPORTED_MODULE_6__["default"])();
  (0,_compare_price_decrypt__WEBPACK_IMPORTED_MODULE_7__["default"])();
  (0,_brands_collection__WEBPACK_IMPORTED_MODULE_1__["default"])();
});
document.addEventListener('cart:updated', _compare_price_decrypt__WEBPACK_IMPORTED_MODULE_7__["default"]);

/***/ },

/***/ "./js/sections/mega-menu.js"
/*!**********************************!*\
  !*** ./js/sections/mega-menu.js ***!
  \**********************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * MegaMenuManager
 * Handles mega menu interactions and dynamic brand cards with ID matching
 */
var MegaMenuManager = (() => {
  var selectors = {
    placeholder: '[data-megamenu-brands-placeholder]',
    brandsContainer: '.megamenu-brands-container',
    brandCard: '.brand-card-item'
  };
  var init = () => {
    console.log('MegaMenuManager initialized');
    populateBrandsPlaceholders();
    setupBrandCards();
    observeSectionChanges();
  };

  /**
   * Clone content from hidden brands sections into mega menu placeholders
   */
  var populateBrandsPlaceholders = () => {
    var placeholders = document.querySelectorAll(selectors.placeholder);
    placeholders.forEach(placeholder => {
      var targetSectionId = placeholder.dataset.targetSection || 'megamenu-brands';
      var sourceContainer = document.getElementById("megamenu-brands-".concat(targetSectionId));
      if (sourceContainer && !placeholder.dataset.populated) {
        // Apply columns setting from source section
        var columns = sourceContainer.dataset.columns;
        if (columns) {
          placeholder.style.setProperty('--promotion-columns', columns);
        }

        // Clone all brand cards from the source container
        var brandCards = sourceContainer.querySelectorAll(selectors.brandCard);
        if (brandCards.length > 0) {
          brandCards.forEach(card => {
            var clonedCard = card.cloneNode(true);
            placeholder.appendChild(clonedCard);
          });

          // Mark as populated to avoid duplicates
          placeholder.dataset.populated = 'true';

          // Show the placeholder
          placeholder.style.display = '';
        }
      }
    });
  };

  /**
   * Setup brand card animations and interactions
   * Sets --index for staggered animation effect
   */
  var setupBrandCards = () => {
    // Set index for each placeholder's cards separately
    var placeholders = document.querySelectorAll(selectors.placeholder);
    placeholders.forEach(placeholder => {
      var cards = placeholder.querySelectorAll(selectors.brandCard);
      cards.forEach((card, index) => {
        card.style.setProperty('--index', index + 1);
      });
    });
  };

  /**
   * Observe Shopify section changes for theme editor support
   */
  var observeSectionChanges = () => {
    document.addEventListener('shopify:section:load', () => {
      // Re-populate on section load
      clearPopulatedFlags();
      populateBrandsPlaceholders();
      setupBrandCards();
    });
    document.addEventListener('shopify:block:select', event => {
      var block = event.target;
      if (block.classList.contains('brand-card-item')) {
        block.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    });
  };

  /**
   * Clear populated flags to allow re-population
   */
  var clearPopulatedFlags = () => {
    var placeholders = document.querySelectorAll(selectors.placeholder);
    placeholders.forEach(placeholder => {
      placeholder.innerHTML = '';
      delete placeholder.dataset.populated;
    });
  };

  /**
   * Refresh - call after dynamic updates
   */
  var refresh = () => {
    clearPopulatedFlags();
    populateBrandsPlaceholders();
    setupBrandCards();
  };
  return {
    init,
    refresh,
    populateBrandsPlaceholders
  };
})();

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', MegaMenuManager.init);
} else {
  MegaMenuManager.init();
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MegaMenuManager);

/***/ },

/***/ "./js/sections/page-redirection.js"
/*!*****************************************!*\
  !*** ./js/sections/page-redirection.js ***!
  \*****************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var pageRedirection = () => {
  var currentUrl = window.location.href;
  if (currentUrl.includes('/policies')) {
    var newUrl = currentUrl.replace('/policies', '/pages');
    window.location.replace(newUrl);
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (pageRedirection);

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; (typeof current == 'object' || typeof current == 'function') && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"global": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","shared"], () => (__webpack_require__("./js/sections/global.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;